import Vue from 'vue'
import elementPopoverContent from './CalendarTooltip'

const CALENDAR_POPOVER_DOM_NODE_ID = 'calendar-popover-container';
const APPEND_WRAPPER_INSTANCE_TO_BODY = false;

function reactiveWrapComponent( component, data ) {
  return new Vue({
    data () {
      return data
    },
    render (h) {
      return h(component, { props: this.$data })
    },
  })
}

export default {
  data: () => ({
  }),
  created: function () {
    this._popoverList = {};

    var containerNode = document.getElementById(CALENDAR_POPOVER_DOM_NODE_ID);
    // console.log("[popover] got containerNode", containerNode);
    if ( !containerNode ) {
      containerNode = document.createElement('div')
      containerNode.setAttribute("id", CALENDAR_POPOVER_DOM_NODE_ID);
      document.body.appendChild( containerNode );
    }

    this.containerNode = containerNode;
    // clear node?
    // this.clearPopoverContainer();
  },
  methods: {
    addCalendarPopover( id, node, eventData ) {
      let reactiveData = {
        reference: node.jquery ? node[0] : node,
        parentData: this.$data,
        eventData: eventData
      }

      if ( id in this._popoverList ) {
        // console.log("Popover for calendar event with id", id, "already exists.");
        // return;
        /* The old DOM-Element doesnt exist anymore, but popper was attached to it,
           so we need to create a new popper (after deleting the current one) */
        this.remCalendarPopover(id);
      }

      /* Create a new Vue component with reactive data */
      var instance = reactiveWrapComponent( elementPopoverContent, reactiveData )

      /* Create vue instance and save reference in _popoverList */
      instance.$mount()
      instance.$parent = this;
      this.$children.push( instance );
      this._popoverList[id] = instance;

      /* append rendered DOM node to containerNode */
      /* not necessary because we use reference */
      var containerNode = document.getElementById(CALENDAR_POPOVER_DOM_NODE_ID); // this.containerNode
      if ( containerNode && APPEND_WRAPPER_INSTANCE_TO_BODY ) {
        containerNode.appendChild( instance.$el );
      }
    },

    remCalendarPopover( id ) {
      if ( id in this._popoverList ) {
        // console.log("[popover] Deleting popover with", id);
        this._popoverList[id].$destroy();
        delete this._popoverList[id]
      }
    },

    clearPopoverContainer() {
      console.log("*************** clearPopoverContainer ***************", Object.keys(this._popoverList).length);
      Object.keys(this._popoverList).forEach(id => {
        this.remCalendarPopover( id );
      });
      this._popoverList = {};

      var containerNode = document.getElementById(CALENDAR_POPOVER_DOM_NODE_ID);
      while (containerNode.firstChild) {
        containerNode.removeChild(containerNode.firstChild);
      }
    }
  },
  beforeDestroy: function() {
    console.log("*** beforeDestroy - not called on HMR ***");
    this.clearPopoverContainer();
  },
  computed: {
    // debug_popoverList() {
    //   return this._popoverList;
    // }
  }
}
